<template>
  <div class="app">
    <!-- 使用路由渲染当前路由组件 -->
    <router-view />

  </div>
</template>

<script setup>
// 由路由动态渲染视图组件,不再直接引入 HomeView
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f5f6fa;
}

.app {
  min-height: 100vh;
  padding: 20px;
}
</style>